module.exports = __webpack_public_path__ + "static/img/01.06f1ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/01.jpg
// module id = QGmo
// module chunks = 0